import { LOCALE_ID, StaticClassProvider } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';

import { LocaleState } from '../redux/state';
import { featureKey } from '../definitions';

// concept based upon https://github.com/angular/angular/issues/15039#issuecomment-494821739

/**
 * Determines the LOCALE_ID for angular freshly everytime its needed, based on the Locale-Manager store.
 */
export class DynamicNgLocale extends String {
  constructor(private readonly store: Store<any>) {
    super();
  }

  toString(): string {
    // We are only resolving the actual LOCALE_ID whenever the string is accessed, to avoid that the pipes
    //  from Angular core are using a stale value (i.e. default EN value even though we got a MDW response
    //  that indicated the prefered locale as FR).
    let result: string;

    this.store
      .select<any>(
        createSelector(
          globalState => globalState[featureKey],
          (state: LocaleState) => state.currentBcpLocale
        )
      )
      .subscribe(v => {
        result = v;
      });

    return result;
  }
}

/**
 * Provider for DynamicNgLocale
 */
export const DynamicNgLocaleProvider: StaticClassProvider = {
  provide: LOCALE_ID,
  useClass: DynamicNgLocale,
  deps: [Store]
};
